"use client";

import { c as _c } from "react/compiler-runtime";
import CrossIcon from "@/Components/Common/Icons/CrossIcon";
import VerifyCheckIcon from "@/Components/Common/Icons/VerifyCheckIcon";
import EmailIcon from "@/Components/website/common/Icons/EmailIcon";
import FillEmailIcon from "@/Components/website/common/Icons/FillEmailIcon";
import LocationFillIcon from "@/Components/website/common/Icons/LocationFillIcon";
import LocationIcon from "@/Components/website/common/Icons/LocationIcon";
import PhoneFillIcon from "@/Components/website/common/Icons/PhoneFillIcon";
import TelePhoneIcon from "@/Components/website/common/Icons/TelePhoneIcon";
import Image from "next/image";
import React from "react";
import { createPortal } from "react-dom";
import Avatar from "react-avatar";
import { sanitizeImageUrl } from "@/utils/imageUrl";
const RepsDetailedPopup = t0 => {
  const $ = _c(47);
  const {
    onClose,
    openAppointment,
    rep,
    openMsg
  } = t0;
  if (typeof document === "undefined") {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CrossIcon fill="white" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <div className=" absolute top-6 right-6 cursor-pointer" onClick={onClose}>{t1}</div>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== rep.profile || $[4] !== rep.repDetails.firstName) {
    t3 = <div className="py-1"><div className="relative w-[130px] h-[130px]">{sanitizeImageUrl(rep.profile) ? <Image height={130} width={130} src={rep.profile} alt="profilepic" className="w-full h-full shadow-lg bg-white rounded-full absolute top-14" /> : <div className="w-full h-full shadow-lg bg-white rounded-full absolute top-14"><Avatar name={rep.repDetails.firstName} size={130} round={true} /></div>}</div></div>;
    $[3] = rep.profile;
    $[4] = rep.repDetails.firstName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="reps-profile-bg w-full reps-bg-image rounded-t-2xl relative px-8  h-[120px] items-center inline-flex">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <g clipRule="url(#clip0_250_8652)"><path d="M23.9136 18.8364L22.5197 14.7797C23.1916 13.4062 23.5467 11.8786 23.5491 10.3416C23.5532 7.66911 22.5192 5.14222 20.6376 3.22643C18.7555 1.31027 16.2476 0.231628 13.5757 0.1893C10.8052 0.145518 8.20099 1.19936 6.24316 3.15715C4.35531 5.04495 3.30822 7.53369 3.27507 10.1932C1.41441 11.5941 0.316178 13.7782 0.319788 16.1112C0.321522 17.2029 0.567242 18.2881 1.03285 19.2694L0.0727093 22.0636C-0.0923379 22.5439 0.0282248 23.0654 0.387382 23.4246C0.640132 23.6774 0.973367 23.812 1.31607 23.812C1.46026 23.812 1.60613 23.7881 1.7484 23.7393L4.54258 22.7791C5.52391 23.2447 6.60911 23.4904 7.70083 23.4922C7.70477 23.4922 7.70852 23.4922 7.71246 23.4922C10.0801 23.4921 12.2809 22.3655 13.6767 20.4593C15.1292 20.421 16.5664 20.0694 17.8656 19.4338L21.9224 20.8278C22.0914 20.8859 22.2647 20.9142 22.4361 20.9142C22.8433 20.9142 23.2393 20.7542 23.5397 20.4538C23.9665 20.027 24.1097 19.4072 23.9136 18.8364ZM7.71236 22.0636C7.70932 22.0636 7.70608 22.0636 7.70304 22.0636C6.73675 22.0622 5.77717 21.8239 4.92822 21.3748C4.75366 21.2825 4.54872 21.2665 4.36206 21.3306L1.49692 22.3151L2.48143 19.45C2.54556 19.2633 2.52962 19.0584 2.43728 18.8839C1.98812 18.0349 1.7499 17.0753 1.7484 16.109C1.74601 14.5547 2.35065 13.0815 3.40801 11.9783C3.75339 14.0837 4.75684 16.0239 6.31225 17.5516C7.85618 19.0681 9.7969 20.0336 11.8909 20.3493C10.7852 21.4391 9.29477 22.0636 7.71236 22.0636ZM22.5295 19.4436C22.4888 19.4843 22.4407 19.4953 22.3865 19.4767L18.0436 17.9844C17.9682 17.9584 17.8897 17.9456 17.8115 17.9456C17.6962 17.9456 17.5814 17.9735 17.4775 18.0285C16.2375 18.6845 14.8363 19.0324 13.4253 19.0345C13.4206 19.0345 13.4164 19.0345 13.4118 19.0345C8.6838 19.0345 4.7785 15.1939 4.70359 10.467C4.66586 8.08649 5.57139 5.84919 7.25332 4.16726C8.93524 2.48534 11.1729 1.58013 13.5531 1.61763C18.2845 1.69268 22.1278 5.6052 22.1205 10.3394C22.1183 11.7504 21.7704 13.1516 21.1145 14.3915C21.0222 14.566 21.0062 14.771 21.0704 14.9577L22.5626 19.3006C22.5812 19.3549 22.5701 19.4031 22.5295 19.4436Z" fill="#354EF0" /><path d="M17.6668 6.53967H9.15618C8.76168 6.53967 8.44189 6.8595 8.44189 7.25396C8.44189 7.64846 8.76172 7.96824 9.15618 7.96824H17.6668C18.0613 7.96824 18.3811 7.64841 18.3811 7.25396C18.3811 6.8595 18.0613 6.53967 17.6668 6.53967Z" fill="#354EF0" /><path d="M17.6668 9.47729H9.15618C8.76168 9.47729 8.44189 9.79712 8.44189 10.1916C8.44189 10.586 8.76172 10.9059 9.15618 10.9059H17.6668C18.0613 10.9059 18.3811 10.586 18.3811 10.1916C18.3811 9.79712 18.0613 9.47729 17.6668 9.47729Z" fill="#354EF0" /><path d="M14.3909 12.4149H9.15618C8.76168 12.4149 8.44189 12.7347 8.44189 13.1292C8.44189 13.5237 8.76172 13.8435 9.15618 13.8435H14.3908C14.7853 13.8435 15.1051 13.5237 15.1051 13.1292C15.1051 12.7347 14.7854 12.4149 14.3909 12.4149Z" fill="#354EF0" /></g>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-6 h-6 relative"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">{t5}<defs><clipPath id="clip0_250_8652"><rect width="24" height="24" fill="white" /></clipPath></defs></svg></div>;
    t7 = <div className="text-blue-600 text-sm font-medium font-poppins">Message</div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== openMsg) {
    t8 = <div onClick={openMsg} className=" cursor-pointer px-2 py-2 hover:shadow-lg rounded-[10px] border border-blue-600 justify-center items-center gap-2.5 inline-flex">{t6}{t7}</div>;
    $[12] = openMsg;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t10;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="w-6 h-6 p-[1.25px] justify-center items-center flex"><div className="w-[21.50px] h-[21.50px] relative"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M17.67 10.25C16.014 10.25 14.67 11.594 14.67 13.25C14.67 14.906 16.014 16.25 17.67 16.25C19.326 16.25 20.67 14.906 20.67 13.25C20.67 11.594 19.326 10.25 17.67 10.25ZM17.67 11.75C18.498 11.75 19.17 12.422 19.17 13.25C19.17 14.078 18.498 14.75 17.67 14.75C16.842 14.75 16.17 14.078 16.17 13.25C16.17 12.422 16.842 11.75 17.67 11.75Z" fill="#354EF0" /><path fillRule="evenodd" clipRule="evenodd" d="M14.827 21.75C16.347 21.75 19 21.75 20.52 21.737C21.081 21.737 21.613 21.459 21.938 20.993C22.263 20.527 22.339 19.932 22.143 19.399C21.49 17.568 19.733 16.25 17.67 16.25C15.61 16.25 13.854 17.564 13.184 19.395C12.986 19.932 13.063 20.532 13.391 21.001C13.718 21.471 14.255 21.75 14.827 21.75ZM14.827 20.25C14.745 20.25 14.668 20.21 14.621 20.143C14.574 20.076 14.563 19.99 14.591 19.913C14.592 19.913 14.592 19.912 14.592 19.912C15.052 18.655 16.256 17.75 17.67 17.75C19.082 17.75 20.284 18.652 20.733 19.91C20.734 19.913 20.734 19.916 20.735 19.918C20.762 19.991 20.752 20.072 20.707 20.135C20.663 20.199 20.591 20.237 20.513 20.237C20.511 20.237 20.509 20.237 20.507 20.237C18.99 20.25 16.343 20.25 14.827 20.25Z" fill="#354EF0" /><path fillRule="evenodd" clipRule="evenodd" d="M20.25 8V5.5C20.25 3.429 18.571 1.75 16.5 1.75H4.5C2.429 1.75 0.75 3.429 0.75 5.5V17.5C0.75 19.571 2.429 21.25 4.5 21.25H10.5C10.914 21.25 11.25 20.914 11.25 20.5C11.25 20.086 10.914 19.75 10.5 19.75C10.5 19.75 7.118 19.75 4.5 19.75C3.257 19.75 2.25 18.743 2.25 17.5V5.5C2.25 4.257 3.257 3.25 4.5 3.25H16.5C17.743 3.25 18.75 4.257 18.75 5.5V8C18.75 8.414 19.086 8.75 19.5 8.75C19.914 8.75 20.25 8.414 20.25 8Z" fill="#354EF0" /><path fillRule="evenodd" clipRule="evenodd" d="M5.5 1V4C5.5 4.414 5.836 4.75 6.25 4.75C6.664 4.75 7 4.414 7 4V1C7 0.586 6.664 0.25 6.25 0.25C5.836 0.25 5.5 0.586 5.5 1Z" fill="#354EF0" /><path fillRule="evenodd" clipRule="evenodd" d="M14 1V4C14 4.414 14.336 4.75 14.75 4.75C15.164 4.75 15.5 4.414 15.5 4V1C15.5 0.586 15.164 0.25 14.75 0.25C14.336 0.25 14 0.586 14 1Z" fill="#354EF0" /><path fillRule="evenodd" clipRule="evenodd" d="M5.5 9.75H8.6C9.014 9.75 9.35 9.414 9.35 9C9.35 8.586 9.014 8.25 8.6 8.25H5.5C5.086 8.25 4.75 8.586 4.75 9C4.75 9.414 5.086 9.75 5.5 9.75Z" fill="#354EF0" /><path fillRule="evenodd" clipRule="evenodd" d="M5.5 13.75H10.5C10.914 13.75 11.25 13.414 11.25 13C11.25 12.586 10.914 12.25 10.5 12.25H5.5C5.086 12.25 4.75 12.586 4.75 13C4.75 13.414 5.086 13.75 5.5 13.75Z" fill="#354EF0" /></svg></div></div>;
    t10 = <div className="text-blue-600 text-sm font-medium  font-poppins">Book Appointment</div>;
    $[14] = t10;
    $[15] = t9;
  } else {
    t10 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[16] !== openAppointment) {
    t11 = <div onClick={openAppointment} className="w-[209px] cursor-pointer px-2 py-2 hover:shadow-lg rounded-[10px] border border-blue-600 justify-center items-center gap-2.5 inline-flex">{t9}{t10}</div>;
    $[16] = openAppointment;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t8) {
    t12 = <div className=" w-full justify-end gap-6 px-4 items-center  inline-flex">{t8}{t11}</div>;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== rep.repDetails.firstName || $[22] !== rep.repDetails.lastName) {
    t13 = <div className="flex  px-6 justify-between pt-2 items-center w-full"><div className=" flex items-center gap-2 text-[#4B4B4B]  font-semibold"><div className=" text-[20px] ">{rep.repDetails.firstName} {rep.repDetails.lastName}</div></div></div>;
    $[21] = rep.repDetails.firstName;
    $[22] = rep.repDetails.lastName;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="text-[14px] font-medium text-chocolateGrey">Contact details</div>;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="flex items-center gap-1"><PhoneFillIcon /><div className="text-[16px] font-light text-coalGrey">Phone:</div></div>;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = rep?.repDetails?.mobileNo || "-";
  let t17;
  if ($[26] !== t16) {
    t17 = <div className="flex items-center pt-2 gap-2">{t15}<div className="text-[16px] font-normal text-coalGrey">{t16}</div></div>;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="flex items-center gap-1"><FillEmailIcon /><div className="text-[16px] font-light text-coalGrey">Email:{" "}</div></div>;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  const t19 = `mailto:${rep?.repDetails?.email}`;
  const t20 = rep?.repDetails?.email;
  let t21;
  if ($[29] !== t19 || $[30] !== t20) {
    t21 = <div className="flex items-center gap-2">{t18}<a target="_blank" href={t19} className="text-[16px] font-normal text-coalGrey">{t20}</a></div>;
    $[29] = t19;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="flex items-center gap-1"><LocationFillIcon /><div className="text-[16px] font-light text-coalGrey">Location:</div></div>;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== rep.addressDetails.country || $[34] !== rep.addressDetails.state) {
    t23 = <div className="flex items-center gap-2">{t22}<div className="text-[16px] font-normal text-coalGrey">{rep.addressDetails.state}, {rep.addressDetails.country}</div></div>;
    $[33] = rep.addressDetails.country;
    $[34] = rep.addressDetails.state;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t21 || $[37] !== t23) {
    t24 = <div className="flex justify-between pt-3 items-center w-full">{t21}{t23}</div>;
    $[36] = t21;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t17 || $[40] !== t24) {
    t25 = <div className="px-6 w-full ">{t14}{t17}{t24}</div>;
    $[39] = t17;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t12 || $[43] !== t13 || $[44] !== t25 || $[45] !== t4) {
    const modal = <><div className="fixed inset-0 popup-bg z-[9999] flex justify-center items-center"><div className="w-[690px] h-[350px]  bg-white rounded-2xl shadow  flex-col justify-start items-start gap-2.5 inline-flex">{t4}{t12}{t13}{t25}</div></div></>;
    t26 = createPortal(modal, document.body);
    $[42] = t12;
    $[43] = t13;
    $[44] = t25;
    $[45] = t4;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  return t26;
};
export default RepsDetailedPopup;